import { stringify } from 'qs';

var updatePageNumber = query => {
  var addQuery = query ? "?".concat(stringify(query)) : '';

  if (window.history.pushState) {
    var path = "".concat(window.location.protocol, "//").concat(window.location.host).concat(window.location.pathname).concat(addQuery);
    window.history.replaceState({
      path
    }, '', path);
  }
};

export default updatePageNumber;